'use client';

import copy from 'copy-to-clipboard';
import styled from 'styled-components';

import { HyperLink } from '@zoomit/icons';
import { useHideAfterXSecond } from '@zoomit/primitives';
import { cssVar, theme } from '@zoomit/zoomit-ds';

type Props = {
  id: string;
};

const HeadingLink = (props: Props) => {
  const { id } = props;

  const { onStart, state: isCopied } = useHideAfterXSecond({ seconds: 3 });
  const handleCopy = () => {
    const url = `${window.location.origin}${window.location.pathname}#${encodeURIComponent(id)}`;
    copy(url);
    onStart();
  };

  return (
    <Root>
      <RelativeWrapper>
        <CustomedHyperLink onClick={handleCopy} className="cursor-pointer" />
        <CopyText $isCopied={isCopied}>{isCopied ? 'کپی شد' : 'کپی لینک'}</CopyText>
      </RelativeWrapper>
    </Root>
  );
};

export default HeadingLink;

const CopyText = styled.div<{ $isCopied: boolean }>`
  font-size: 1.2rem;
  text-align: center;
  color: ${({ $isCopied }) => cssVar($isCopied ? theme.success1 : theme.black3)};
  background-color: ${cssVar(theme.card)};
  width: 6.5rem;
  padding: 1rem 0;
  border-radius: var(${theme.radius.sm});
  position: absolute;
  top: -3.4rem;
  right: 50%;
  transform: translateX(50%);
  filter: drop-shadow(0 0 0.5rem ${cssVar(theme.elevation)});
  transition: opacity 0.2s ease-in-out;
  opacity: 0;

  &:after {
    content: '';
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0.5rem;
    border-style: solid;
    border-color: ${cssVar(theme.card)} transparent transparent transparent;
  }
`;

const Root = styled.div`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  height: 100%;
  place-items: center;
  right: -3.6rem;
  width: 3.6rem;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
  display: grid;
`;

const CustomedHyperLink = styled(HyperLink)`
  cursor: pointer;

  &:hover + ${CopyText} {
    opacity: 1;
  }
`;

const RelativeWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  place-items: center;
`;
